<script>
   /*************************************************************/
   /* VariancePlot                                              */
   /* --------------------                                      */
   /* shows plot with variance values vs. number of PCs         */
   /*************************************************************/

   import { Axes, XAxis, YAxis, Box } from 'svelte-plots-basic/2d';
   import { Vector, vector } from 'mdatools/arrays';

   import { PNG_WIDTH, PNG_HEIGHT, PNG_RES, MARGINS, FACE_COLORS } from '../../../shared/plots/Defaults.js';
   import PlotSeries from '../../../shared/plots/PlotSeries.svelte';

   export let params;                     // JSON with main plot parameters
   export let res;                        // JSON with PCA results

   export let showGrid = true;
   export let fileName = 'plot-variance';
   export let pngWidth = PNG_WIDTH;
   export let pngHeight = PNG_HEIGHT;
   export let pngRes = PNG_RES;


   /*****************************************/
   /* Component code                        */
   /*****************************************/

   // constant plot parameters
   const xLabel = 'Number of PCs';
   const yLabel = 'Variance';
   const titles = {
      'expvar': 'Explained variance',
      'resvar': 'Residual variance',
      'cumexpvar': 'Cumulative explained variance',
      'cumresvar': 'Cumulative residual variance'
   };

   let varType = 'exp';
   let varForm = 'cum';
   let plotType = 'b';
   let showLabels = 'hide';

   // reactive expressions to monitor changes in plot parameters
   $: if (params && params.varType !== varType) varType = params.varType;
   $: if (params && params.varForm !== varForm) varForm = params.varForm;
   $: if (params && params.plotType !== plotType) plotType = params.plotType;
   $: if (params && params.showLabels !== showLabels) showLabels = params.showLabels;

   $: statName = varForm + varType + 'var';
   $: title = titles[statName];

   // reactive computation of y limits
   $: limY = [-0.05, 1.1];
   $: limX = res ? [1 - res.ncomp / 20, res.ncomp + res.ncomp / 20] : [0, 1];
   $: xValues = res ? Vector.seq(1, res.ncomp) : null;
   $: yValues = res ? vector(res.stat[statName]) : null;
   $: labels = yValues ? Array.from(yValues.v).map(v => v.toFixed(v < 0.1 ? 3 : 2)) : null;
</script>

{#if res && xValues && yValues }
<Axes {title} {xLabel} {yLabel} {limX} {limY}
   {fileName} {pngWidth} {pngHeight} {pngRes}
   downloadLinks="hover"
   margins={MARGINS}
>
   <slot name="before"></slot>

   <!-- data points  -->
   <PlotSeries
      {xValues}
      {yValues}
      {plotType}
      {showLabels}
      {labels}
      faceColor={FACE_COLORS['cal']}
      lineWidth={1.5}
      seriesTitle="variance"
   />


   <XAxis {showGrid} slot="xaxis" whole={true} />
   <YAxis {showGrid} slot="yaxis" />
   <Box slot="box" />
</Axes>{/if}